module.exports = "<md-list>\r\n    <md-list-item ng-repeat=\"page in $ctrl.pages\" ui-sref=\"{{page.state}}\">\r\n        <md-icon class=\"material-icons\">{{ page.icon }}</md-icon>\r\n        {{ page.label }}\r\n        <span flex></span>\r\n    </md-list-item>\r\n</md-list>\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/common/nav/nav.html
 ** module id = 11
 ** module chunks = 0
 **/